import { render, staticRenderFns } from "./UserGroupUserAddForm.vue?vue&type=template&id=6e15cbd0&scoped=true"
import script from "./UserGroupUserAddForm.vue?vue&type=script&lang=js"
export * from "./UserGroupUserAddForm.vue?vue&type=script&lang=js"
import style0 from "./UserGroupUserAddForm.vue?vue&type=style&index=0&id=6e15cbd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e15cbd0",
  null
  
)

export default component.exports